import http from '@/http'
const URL = '/admin'

export const checkEmail = (payload) => http.post(URL + '/confirmation/login', payload)
export const updateRegister = (payload) => http.post(URL + '/confirmation/update', payload)

export default {
  checkEmail,
  updateRegister
}
